import { sumBy } from "es-toolkit";
import type { InvoiceItem } from "./types.common";

interface InvoiceItemUnit {
    price: number;
    wholePrice?: boolean;
    quantity: number;
}

export function calculateItemPrice(item: InvoiceItemUnit) {
    let price = 0;
    if (item.wholePrice === true) {
        price = item.price;
    } else {
        price = item.price * item.quantity;
    }

    return price;
}

export function calculateInvoiceNumbers(
    items: InvoiceItem[],
    discounts: {
        name: string;
        cost: number;
    }[] = [],
) {
    let sumTotal = 0;
    let sumDiscount = 0;
    let taxAddition = 0;

    for (const item of items) {
        let price = 0;
        if (item.wholePrice === true) {
            price = item.price;
        } else {
            price = item.price * item.quantity;
        }

        sumTotal += price;
        sumDiscount += item.discount;
        price -= item.discount;

        const tax = (item.tax ?? 0) / 100;
        taxAddition += Math.floor(tax * price);

        // Adjust tax to make it round
        const itemTax = Math.floor(tax * price);
        if ((price + itemTax) % 10 !== 0) {
            if ((price + itemTax + 1) % 10 === 0) {
                taxAddition += 1;
            } else if ((price + itemTax - 1) % 10 === 0) {
                taxAddition -= 1;
            }
        }
    }

    let subTotal = sumTotal - Math.min(sumDiscount, sumTotal);
    const totalDiscount = sumBy(discounts, (discount) => discount.cost);
    const discountValue = Math.min(totalDiscount, subTotal);

    if (subTotal > 0) {
        const discountRatio = discountValue / subTotal;
        subTotal -= discountValue;
        taxAddition -= Math.ceil(discountRatio * taxAddition);
    }

    return {
        sumTotal: sumTotal,
        subTotal: subTotal,
        sumDiscount: sumDiscount,
        taxAddition: taxAddition,
        discountSub: discountValue,
        grandTotal: subTotal + taxAddition,
    } as const;
}
